"use strict";

exports.__esModule = true;
exports.ReportListScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _Auth = require("../../Auth");
var _App = require("../../App");
var _ReportCollection = require("../ReportCollection");
var _API = require("../../API");
var _ReportList = require("../ReportList/ReportList");
var _ReportListAccordianView = require("../ReportListAccordianView");
var _System = require("../../../System");
var _Theme = require("../../Theme");
var _ReportGridView = require("../ReportGridView");
var _ReportTagContext = require("../ReportTagContext");
var _AiCreateButton = require("../../AI/Authoring/AiCreateButton");
var _dec, _class, _ReportListScreen;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var StyledReportList = (0, _styledComponents["default"])(_ReportList.ReportList).withConfig({
  displayName: "ReportListScreen__StyledReportList",
  componentId: "sc-1mpsiq9-0"
})(["overflow-y:auto;height:calc(100vh - (", " + ", "));"], (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("ToolbarHeight"));
var StyledReportListAccordianView = (0, _styledComponents["default"])(_ReportListAccordianView.ReportListAccordianView).withConfig({
  displayName: "ReportListScreen__StyledReportListAccordianView",
  componentId: "sc-1mpsiq9-1"
})(["overflow-y:auto;height:calc(100vh - (", " + ", "));"], (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("ToolbarHeight"));
var StyledReportGridView = (0, _styledComponents["default"])(_ReportGridView.ReportGridView).withConfig({
  displayName: "ReportListScreen__StyledReportGridView",
  componentId: "sc-1mpsiq9-2"
})(["overflow-y:auto;height:calc(100vh - (", " + ", "));"], (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("ToolbarHeight"));

/**
 * Screen which shows a list of reports for the plant.
 */
var ReportListScreen = exports.ReportListScreen = (_dec = _ReportCollection.ReportCollectionContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (_ReportListScreen = /*#__PURE__*/function (_Component) {
  function ReportListScreen() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      searchTerm: "",
      view: "accordian"
    };
    _this.handleSearchChange = function (searchTerm) {
      _this.setState({
        searchTerm: searchTerm
      });
    };
    _this.handeChangeView = function (view) {
      _this.setState({
        view: view
      });
    };
    return _this;
  }
  _inheritsLoose(ReportListScreen, _Component);
  var _proto = ReportListScreen.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      translator = _this$props.translator,
      reportCollection = _this$props.reportCollection;
    var translate = translator.translate;
    var _this$state = this.state,
      searchTerm = _this$state.searchTerm,
      view = _this$state.view;
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("ReportListScreen.title", "Reports"),
      "data-testid": "ReportListScreen"
    }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: translate("ReportListScreen.navbar.title", "Reports")
    }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_Core.LeftToolbarContent, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
      value: searchTerm,
      onChange: this.handleSearchChange
    })), /*#__PURE__*/_react["default"].createElement(_Core.RightToolbarContent, null, /*#__PURE__*/_react["default"].createElement(_Core.LayoutButtons, {
      onChangeLayout: this.handeChangeView,
      selected: view
    }), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
      permission: "CREATE_REPORTS"
    }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: (0, _System.getScreenURL)("CreateReport"),
      intent: _core.Intent.PRIMARY
    }, translate("ReportListScreen.createReportButton.text", "Create Report"))), /*#__PURE__*/_react["default"].createElement(_AiCreateButton.AiCreateButton, {
      kind: "report",
      style: {
        marginLeft: 6
      }
    }))), /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
      collection: reportCollection,
      term: searchTerm,
      parseSearchItem: function parseSearchItem(item) {
        return {
          name: item.name,
          description: item.element.props.description
        };
      }
    }, function (_ref) {
      var reports = _ref.data,
        error = _ref.error;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error
        });
      }
      if (!reports) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      var sortedData = (0, _Core.applySort)(reports, "name", "asc");
      switch (view) {
        case "thumbnails":
          return /*#__PURE__*/_react["default"].createElement(StyledReportGridView, {
            items: sortedData
          });
        case "list":
          return /*#__PURE__*/_react["default"].createElement(StyledReportList, {
            items: sortedData
          });
        case "accordian":
          return /*#__PURE__*/_react["default"].createElement(_ReportTagContext.ReportTagContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_ReportTagContext.ReportTagContext.Consumer, null, function (_ref2) {
            var loading = _ref2.loading,
              reportTags = _ref2.data;
            if (loading) {
              return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
            }
            return /*#__PURE__*/_react["default"].createElement(StyledReportListAccordianView, {
              items: sortedData,
              tags: reportTags
            });
          }));
        default:
          return /*#__PURE__*/_react["default"].createElement(StyledReportList, {
            items: sortedData,
            compact: true
          });
      }
    }));
  };
  return ReportListScreen;
}(_react.Component), _ReportListScreen.defaultProps = {
  translator: undefined,
  reportCollection: undefined
}, _ReportListScreen)) || _class) || _class);